//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { MediaLibrarySourcesDropdownItemData } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import { SourcesModal } from '@media-library/components/top-bar/sources-modals/SourcesModal';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface AllTrackedHashtagsModalProps {
  handleChangeSelects: (
    updatedSources: MediaLibrarySourcesDropdownItemData,
  ) => void;
  handleCloseModal: () => void;
  isOpen: boolean;
  trackedHashtags: MediaLibrarySourcesDropdownItemData;
}

export const AllTrackedHashtagsModal = ({
  handleChangeSelects,
  handleCloseModal,
  isOpen,
  trackedHashtags,
}: AllTrackedHashtagsModalProps) => {
  return (
    <SourcesModal
      applyButtonTrackingId={
        MediaLibraryTrackingIds.APPLY_ALL_TRACKED_HASHTAGS_MODAL
      }
      cancelButtonTrackingId={
        MediaLibraryTrackingIds.CLOSE_ALL_TRACKED_HASHTAGS_MODAL
      }
      handleChangeSelects={handleChangeSelects}
      handleCloseModal={handleCloseModal}
      isOpen={isOpen}
      searchBarPlaceholder='Search hashtags'
      searchBarTrackingIdPrefix={
        MediaLibraryTrackingIds.ALL_TRACKED_HASHTAGS_MODAL_SEARCH_BAR
      }
      searchBarVisuallyHiddenLabel='Search hashtags'
      sourcesGroup={trackedHashtags}
      tertiaryButtonInfo={{
        content: 'Manage Tracked Hashtags',
        state: 'library.tracked-sources.hashtag',
        trackingId:
          MediaLibraryTrackingIds.ALL_TRACKED_HASHTAGS_MODAL_MANAGE_TRACKED_HASHTAGS_LINK,
      }}
      title='All Tracked Hashtags'
    />
  );
};
